import { __extends } from "tslib";
import * as React from 'react';
import { View, Image } from 'react-native';
var PnmacActivityIndicator = /** @class */function (_super) {
  __extends(PnmacActivityIndicator, _super);
  function PnmacActivityIndicator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacActivityIndicator.prototype.render = function () {
    var _a = this.props,
      size = _a.size,
      image = _a.image;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        display: 'flex',
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement(Image, {
      style: {
        position: 'absolute',
        height: size,
        width: size
      },
      source: image
    }));
  };
  return PnmacActivityIndicator;
}(React.Component);
export default PnmacActivityIndicator;